import useToggleState from 'Utils/hooks/useToggleState'

import { useAppDetailContext } from '../../AppDetailContext'
import InstallApp from '../../../components/InstallApp'
import ConfluenceAuthForm from './ConfluenceAuthForm'

const InstallConfluence = ({ app }) => {
  const { title } = useAppDetailContext()
  const [showCredentialsForm, toggleCrdentialsForm] = useToggleState(false)

  if (showCredentialsForm) {
    return <ConfluenceAuthForm onCancel={toggleCrdentialsForm} app={app} />
  }

  return <InstallApp name={title} onInstall={toggleCrdentialsForm} />
}

export default InstallConfluence
